/* eslint-disable import/no-cycle */
import { reactive, ref } from 'vue';
import { readBlockTaxonomies } from './graphql/readBlockTaxonomies';
import { routing } from './routing.js';

export const filters = reactive([]);

export const titleFilter = ref('');

export const filtersHaveLoaded = ref(false);

/*
    Sets filters via the 'readBlockTaxonomies' graphQL call.

    Taxonomy Types and Terms become Filters and Options.

    Example output:

    filters: [
        {
            id: 1,
            name: 'taxonomy type 1',
            options: [
                {
                    id: 2,
                    name: 'term 1',
                    checked: false
                },
                {
                    id: 3,
                    name: 'term 2',
                    checked: false
                }

            ]
        }
    ]
*/
export async function setFilters() {

    const url = new URL(document.location);
    const params = new URLSearchParams(url.search);

    const taxonomies = await readBlockTaxonomies();

    if (taxonomies.length > 0) {

        for (let i = 0; i < taxonomies.length; i++) {

            const type = taxonomies[i][0];

            const filter = {
                id: type.id,
                name: type.name,
                options: [],
            };

            if (type.terms && type.terms.nodes.length > 0) {

                const terms = type.terms.nodes;

                for (let j = 0; j < terms.length; j++) {

                    filter.options.push({
                        id: terms[j].id,
                        name: terms[j].name,
                        checked: false,
                    });

                    if (j === terms.length - 1) {

                        filters.push(filter);

                        if (i === taxonomies.length - 1) {

                            routing.updateFiltersFromUrl(params);

                            /*
                                results.vue watches the filters and grabs new
                                results every time they change. 'filtersHaveLoaded'
                                is a boolean which prevents results.vue from
                                trying to grab results before we add the initial
                                state to the filters
                            */
                            filtersHaveLoaded.value = true;

                        }

                    }

                }

            } else if (i === taxonomies.length - 1) {

                routing.updateFiltersFromUrl(params);
                filtersHaveLoaded.value = true;

            }

        }

    }

}
